// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-pen-line.js';

import { paths } from '../generated/file-pen-line';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-pen-line', Original, paths);
